import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import IconPlay from 'components/icons/IconPlay';
import IconPlus from 'components/icons/iconPlus';
import useVideoMetadata from 'hooks/useVideoMetadata';
import PDPGalleryRevampLifestyleThumb from './PDPGalleryRevampLifestyleThumb';

// Five top-aligned slots: video, lifestyle photos, "+" overflow
const TILE_SLOTS = 5;
const THUMB_CLASS = 'h-[42px] w-full';
const PDPGalleryRevampLifestyleRail = t0 => {
  const $ = _c(15);
  const {
    introVideoId,
    isVideoSelected: t1,
    onExpand,
    onSelectVideo,
    photos: t2,
    viewGalleryImageEvent
  } = t0;
  const isVideoSelected = t1 === undefined ? false : t1;
  const photos = t2 === undefined ? [] : t2;
  let t3;
  if ($[0] !== introVideoId) {
    t3 = {
      videoId: introVideoId
    };
    $[0] = introVideoId;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const {
    thumbnail: videoThumbnailUrl
  } = useVideoMetadata(t3);
  if (!photos.length) {
    return null;
  }
  const reservedSlots = introVideoId ? 1 : 0;
  const hasOverflow = photos.length > TILE_SLOTS - reservedSlots;
  const photoCount = Math.max(1, TILE_SLOTS - reservedSlots - (hasOverflow ? 1 : 0));
  const railPhotos = photos.slice(0, photoCount);
  const t4 = "flex flex-col gap-1.5 w-14";
  const t5 = "PDPGalleryRevampLifestyleRail";
  let t6;
  if ($[2] !== introVideoId || $[3] !== isVideoSelected || $[4] !== onSelectVideo || $[5] !== videoThumbnailUrl) {
    t6 = !!introVideoId && <PDPGalleryRevampLifestyleThumb ariaLabel="Play product video" className={THUMB_CLASS} src={videoThumbnailUrl} isSelected={isVideoSelected} onClick={onSelectVideo} icon={<IconPlay width={20} height={20} />} />;
    $[2] = introVideoId;
    $[3] = isVideoSelected;
    $[4] = onSelectVideo;
    $[5] = videoThumbnailUrl;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  const t8 = railPhotos.map((t7, index) => {
    const {
      id,
      src
    } = t7;
    return <PDPGalleryRevampLifestyleThumb key={`PDPGalleryRevampRailThumb${id}`} className={THUMB_CLASS} src={src} onClick={() => {
      onExpand(index);
      viewGalleryImageEvent?.({
        imageLocation: "Hero Gallery",
        imageFilename: src?.split("/").pop() || "",
        position: index,
        totalImages: photos.length
      });
    }} />;
  });
  let t9;
  if ($[7] !== hasOverflow || $[8] !== onExpand || $[9] !== photos) {
    t9 = hasOverflow && <PDPGalleryRevampLifestyleThumb ariaLabel={`Show all ${photos.length} photos`} className={THUMB_CLASS} borderClass="border-gray-light5" onClick={() => onExpand(0)}><IconPlus width={14} height={14} /></PDPGalleryRevampLifestyleThumb>;
    $[7] = hasOverflow;
    $[8] = onExpand;
    $[9] = photos;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] !== t6 || $[12] !== t8 || $[13] !== t9) {
    t10 = <div className={t4} data-xc={t5}>{t6}{t8}{t9}</div>;
    $[11] = t6;
    $[12] = t8;
    $[13] = t9;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  return t10;
};
PDPGalleryRevampLifestyleRail.propTypes = {
  introVideoId: PropTypes.string,
  isVideoSelected: PropTypes.bool,
  onExpand: PropTypes.func,
  onSelectVideo: PropTypes.func,
  photos: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    src: PropTypes.string.isRequired
  })),
  viewGalleryImageEvent: PropTypes.func
};
export default PDPGalleryRevampLifestyleRail;